import { lazyWithPreload } from '../../navigation';

export * from './RedirectWithSitePreview';

export const SiteScreen = lazyWithPreload(() =>
    import('./SiteScreen').then((m) => ({ default: m.SiteScreen }))
);
